import { useCallback, useEffect, useState } from 'react';
import {
  fetchItemReservationOverlays,
  type ItemReservationOverlay,
} from '@/modules/reservations/services';

export function useItemReservationOverlays() {
  const [overlays, setOverlays] = useState<Map<string, ItemReservationOverlay>>(
    new Map(),
  );
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      setOverlays(await fetchItemReservationOverlays());
    } catch {
      setOverlays(new Map());
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { overlays, loading, refresh };
}
